import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import TaxForm from "./TaxForm";
import {
  updateTax,
  getTaxById,
} from "../../api/TaxService";
import FullPageLoader from "../../common/FullPageLoader";

export default function EditTax() {
  const location = useLocation();
  const taxId = location?.state?.taxId;

  const [taxData, setTaxData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    fetchTax();
  }, []);

  const fetchTax = async () => {
    try {
      const res = await getTaxById(taxId);

      

      const data = res?.data || res;

      setTaxData(data);
    } catch (err) {
      console.log(err);
    } finally {
      setPageLoading(false);
    }
  };

  const handleSubmit = async (formData) => {
    setLoading(true);

    try {
      const res = await updateTax(taxId, formData);
      return res;
    } catch (err) {
      return err?.response?.data;
    } finally {
      setLoading(false);
    }
  };

  if (pageLoading) {
    return <FullPageLoader text="Loading tax..." />;
  }

  return (
    <TaxForm
      isEdit={true}
      initialData={taxData}
      onSubmit={handleSubmit}
      loading={loading}
    />
  );
}
